import { render } from "./oap-tab.vue?vue&type=template&id=706c500a"
import script from "./oap-tab.vue?vue&type=script&lang=js"
export * from "./oap-tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__